<template>
    <div>
        <slot :openGalleryModal="openGalleryModal"  />

        <portal to="modals">
            <transition name="fade">
                <modal
                    v-if="open"
                    @close="closeGalleryModal()"
                    class="modal--full  modal--full--dark-transparent  modal--higher"
                    :full="true"
                >
                    <div slot="wiggle" class="wiggle">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1132 175.83" class="white"><g><g><path style="fill-rule:evenodd;" d="M1132,0V175.83H0V79.23c18.71,1,21.35,22.34,42.05,20.89,21.9-1.53,20.23-25.48,42.13-27S107.77,95.52,129.68,94s20.23-25.47,42.13-27,23.59,22.41,45.5,20.88,20.23-25.48,42.13-27S283,83.24,304.93,81.71s20.23-25.47,42.13-27,23.58,22.41,45.49,20.88,20.23-25.48,42.14-27S458.27,71,480.18,69.44s20.23-25.48,42.14-27S545.9,64.84,567.81,63.3,588,37.83,610,36.29s23.58,22.41,45.49,20.88,20.23-25.48,42.14-27S721.16,52.56,743.07,51s20.23-25.48,42.14-27,23.59,22.41,45.5,20.87,20.23-25.47,42.13-27,23.59,22.41,45.5,20.88,20.23-25.48,42.14-27,23.58,22.4,45.49,20.87,20.24-25.48,42.15-27,23.59,22.41,45.5,20.87C1114.19,25,1114,3.86,1132,0Z"/></g></g></svg>


                    </div>

                    <div class="carousel  js-carousel">
                        <slot name="modal" />
                    </div>
                </modal>
            </transition>
        </portal>
    </div>
</template>

<script>
export default {
    name: 'GalleryComponent',

    data: () => ({
        open: false,
        options: {
            main: {
                pageDots: false,
                prevNextButtons: false,
                autoPlay: false,
                wrapAround: true
            },
            nav: {
                asNavFor: ".js-carousel-main",
                pageDots: false,
                prevNextButtons: false,
                autoPlay: false,
                wrapAround: true,
                cellAlign: "left"
            }
        },
    }),

    mounted() {
    },

    methods: {
        openGalleryModal(index) {
            this.open = true;

            let vm = this
            setTimeout(function() {
                let main = new Flickity('.js-carousel-main', vm.options.main);
                let nav = new Flickity('.js-carousel-nav', vm.options.nav);

                main.select(index, true, true);

                let el = document.querySelector('.js-carousel');
                el.classList.add('active');
            }, 100)
        },
        closeGalleryModal() {
            let el = document.querySelector('.js-carousel');
            el.classList.remove('active');

            let vm = this
            setTimeout(function() {
                vm.open = false;
            }, 100)
        }
    },
}
</script>



// WEBPACK FOOTER //
// Gallery.vue?ab34ded6